import { createAction } from 'redux-actions'
import axios from 'axios'
import * as storage from '../../utils/storage'

var axiosInstance = axios.create({
    baseURL: process.env.project.API_URL.toString(),
    timeout: 60000
})
/*
//var cadena = "http://localhost:8800";
var cadena = "https://checkouttest.ecolon.com.ar";

var axiosInstance = axios.create({
    baseURL: cadena.toString(),
    timeout: 60000
})
*/
//
// API - NOT FOR EXPORT
//

const getHeaders = function(params = {}, contentType) {
    var queryParams = {}
    Object.keys(params).forEach(key => {
        if (key !== 'limit' && key !== 'skip') {
            queryParams[key] = JSON.stringify(params[key])
        } else {
            queryParams[key] = params[key]
        }
    })
    if (!contentType) {
        contentType = 'application/json'
    }
    var headers = {
        'Accept': 'application/json',
        'Content-Type': contentType
    }
    var accessToken = storage.get(storage.accessTokenKey)
    if (accessToken) {
        headers['Authorization'] = 'Bearer ' + accessToken
    }
    return {
        headers: headers,
        params: queryParams
    }
}

const apiCall = function(method, url, data, config) {
    return axiosInstance[method](url, data, config).then(function(response) {
        if (response.status >= 200 && response.status < 300) {
            // if (process.env.MT_ENV == 'development') {
            //     console.log('API call succeeded: ', response)
            // }
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    }).catch(function(error) {
        // if (process.env.MT_ENV == 'development') {
        //     console.log('API call failed: ', url, error)
        // }
        return Promise.reject({
            error: error
        })
    })
}

//
// ACTIONS - FOR EXPORT
//

// API
export const API_CLEAN = 'API_CLEAN'
export const IS_READY = 'IS_READY'

// APPS
export const APP_ADD = 'APP_ADD'
export const APP_EDIT = 'APP_EDIT'
export const APP_DELETE = 'APP_DELETE'
export const APP_GET = 'APP_GET'
export const APP_GET_ONE = 'APP_GET_ONE'
export const APP_GET_ONE_CODENAME = 'APP_GET_ONE_CODENAME'
export const APP_CLEAN = 'APP_CLEAN'
export const APP_CLEAN_ONE = 'APP_CLEAN_ONE'
export const APP_RESET = 'APP_RESET'
export const APP_NEW_TOKEN = 'APP_NEW_TOKEN'
export const APP_SELECT = 'APP_SELECT'

// USERS
export const LOGIN_USER = 'LOGIN_USER'
export const USER_ADD = 'USER_ADD'
export const USER_EDIT = 'USER_EDIT'
export const USER_DELETE = 'USER_DELETE'
export const USER_GET = 'USER_GET'
export const USER_GET_ONE = 'USER_GET_ONE'
export const USER_CLEAN = 'USER_CLEAN'
export const USER_CHANGE_PASSWORD = 'USER_CHANGE_PASSWORD'
export const USER_GET_PROFILE = 'USER_GET_PROFILE'
export const USER_CLEAN_PROFILE = 'USER_CLEAN_PROFILE'

// STATS
export const GET_STATS = 'GET_STATS'
export const CLEAN_STATS = 'CLEAN_STATS'

// TRANSACTIONS
export const TRANSACTIONS_GET = 'TRANSACTIONS_GET'
export const TRANSACTIONS_GET_ONE = 'TRANSACTIONS_GET_ONE'
export const TRANSACTIONS_CLEAN = 'TRANSACTIONS_CLEAN'
export const TRANSACTIONS_CLEAN_ONE = 'TRANSACTIONS_CLEAN_ONE'
export const TRANSACTIONS_DOWNLOAD_CSV = 'TRANSACTIONS_DOWNLOAD_CSV'
export const TRNSACTION_CANCEL_SAVEUP = 'TRNSACTION_CANCEL_SAVEUP'

// ENTITY
export const ENTITY_GET = 'ENTITY_GET'
export const ENTITY_GET_ONE = 'ENTITY_GET_ONE'
export const ENTITY_REFRESH_CREDENTIALS = 'ENTITY_REFRESH_CREDENTIALS'
export const ENTITY_CLEAN = 'ENTITY_CLEAN'
export const ENTITY_CLEAN_ONE = 'ENTITY_CLEAN_ONE'

// SUBSCRIPTION
export const SUBSCRIPTION_GET = 'SUBSCRIPTION_GET'
export const SUBSCRIPTION_GET_ONE = 'SUBSCRIPTION_GET_ONE'
export const SUBSCRIPTION_CLEAN = 'SUBSCRIPTION_CLEAN'
export const SUBSCRIPTION_CLEAN_ONE = 'SUBSCRIPTION_CLEAN_ONE'
export const SUBSCRIPTION_PUT_STATUS = 'SUBSCRIPTION_PUT_STATUS'

// API
export const apiClean = createAction(API_CLEAN, function() {
    return Promise.resolve()
})

export const isReady = createAction(IS_READY, function() {
    return Promise.resolve()
})

// APPS
export const appAdd = createAction(APP_ADD, function(app) {
    return apiCall('post', '/api/v1/app', app, getHeaders())
})

export const appEdit = createAction(APP_EDIT, function(appId, app) {
    return apiCall('put', '/api/v1/app/' + appId, app, getHeaders())
})

export const appDelete = createAction(APP_DELETE, function(appId) {
    return apiCall('delete', '/api/v1/app/' + appId, getHeaders())
})

export const appReset = createAction(APP_RESET, function(appCodename, query, params) {
    let queryParams = Object.assign({}, params, query)
    return apiCall('get', '/api/v1/app/' + appCodename + '/reset', getHeaders(queryParams))
})

export const appNewToken = createAction(APP_NEW_TOKEN, function(appCodename) {
    return apiCall('get', '/api/v1/app/' + appCodename + '/newtoken', getHeaders())
})

export const appGet = createAction(APP_GET, function(query, params) {
    let queryParams = Object.assign({}, params, query)
    return apiCall('get', '/api/v1/app', getHeaders(queryParams))
})

export const appGetOne = createAction(APP_GET_ONE, function(appId) {
    return apiCall('get', '/api/v1/app/' + appId, getHeaders())
})

export const appGetOneCodename = createAction(APP_GET_ONE_CODENAME, function(appCodename) {
    return apiCall('get', '/api/v1/app/codename/' + appCodename, getHeaders())
})

export const appClean = createAction(APP_CLEAN, function() {
    return Promise.resolve()
})

export const appCleanOne = createAction(APP_CLEAN_ONE, function() {
    return Promise.resolve()
})

export const appSelect = createAction(APP_SELECT, function(app) {
    return Promise.resolve(app)
})

// USERS
export const userLogin = createAction(LOGIN_USER, function(user) {
    return apiCall('post', '/api/v1/user/login', user)
})

export const userAdd = createAction(USER_ADD, function(appCodename, user) {
    return apiCall('post', '/api/v1/' + appCodename + '/user', user, getHeaders())
})

export const userEdit = createAction(USER_EDIT, function(appCodename, userId, user) {
    return apiCall('put', '/api/v1/' + appCodename + '/user/' + userId, user, getHeaders())
})

export const userDelete = createAction(USER_DELETE, function(appCodename, userId) {
    return apiCall('delete', '/api/v1/' + appCodename + '/user/' + userId, getHeaders())
})

export const userGet = createAction(USER_GET, function(appCodename, query, params) {
    let queryParams = Object.assign({}, params, query)
    return apiCall('get', '/api/v1/' + appCodename + '/user', getHeaders(queryParams))
})

export const userGetOne = createAction(USER_GET_ONE, function(appCodename, userId) {
    return apiCall('get', '/api/v1/' + appCodename + '/user/' + userId, getHeaders())
})

export const userClean = createAction(USER_CLEAN, function() {
    return Promise.resolve()
})

export const userChangePassword = createAction(USER_CHANGE_PASSWORD, function(userId, user) {
    return apiCall('put', '/api/v1/user/' + userId + '/changePassword', user, getHeaders())
})

export const userGetProfile = createAction(USER_GET_PROFILE, function() {
    return apiCall('get', '/api/v1/user/me/profile', getHeaders())
})

export const userCleanProfile = createAction(USER_CLEAN_PROFILE, function() {
    return Promise.resolve()
})

// STATS
export const getStats = createAction(GET_STATS, function(appCodename, params) {
    return apiCall('get', '/api/v1/' + appCodename + '/stats', getHeaders(params))
})

export const cleanStats = createAction(CLEAN_STATS, function(appCodename) {
    return Promise.resolve()
})

// TRANSACTIONS
export const transactionsGet = createAction(TRANSACTIONS_GET, function (appCodename, query, params) {
    let queryParams = Object.assign({}, params, query)
    queryParams.sort = {
        createdAt: -1
    }
    return apiCall('get', '/api/v1/' + appCodename + '/transaction', getHeaders(queryParams))
})

export const transactionsGetOne = createAction(TRANSACTIONS_GET_ONE, function(appCodename, transactionId) {
    return apiCall('get', '/api/v1/' + appCodename + '/transaction/' + transactionId, getHeaders())
})

export const transactionsClean = createAction(TRANSACTIONS_CLEAN, function() {
    return Promise.resolve()
})

export const transactionsCleanOne = createAction(TRANSACTIONS_CLEAN_ONE, function() {
    return Promise.resolve()
})

export const transactionsDescargarCsv = createAction(TRANSACTIONS_DOWNLOAD_CSV, function(appCodename, query) {
    let query1 = {query: query}
    query1.sort = {
        createdAt: -1
    }
    return apiCall('get', '/api/v1/' + appCodename + '/transaction/generate/csv', getHeaders(query1))
})

export const cancelSaveup = createAction(TRNSACTION_CANCEL_SAVEUP, function(appCodename, transactionId) {
    return apiCall('put', '/api/v1/' + appCodename + '/mercadopago/cancel/capture/' + transactionId, {}, getHeaders())
})

// ENTITY
export const entityGet = createAction(ENTITY_GET, function (appCodename, query, params) {
    let queryParams = Object.assign({}, params, query)
    queryParams.sort = {
        createdAt: -1
    }
    return apiCall('get', '/api/v1/' + appCodename + '/entity', getHeaders(queryParams))
})

export const refreshCredentials = createAction(ENTITY_REFRESH_CREDENTIALS, function(appCodename, entity) {
    return apiCall('post', '/api/v1/' + appCodename + '/' + entity.platform + '/app/credentials', entity, getHeaders())
})

export const entityGetOne = createAction(ENTITY_GET_ONE, function(appCodename, entityId) {
    return apiCall('get', '/api/v1/' + appCodename + '/entity/' + entityId, getHeaders())
})

export const entityClean = createAction(ENTITY_CLEAN, function() {
    return Promise.resolve()
})

export const entityCleanOne = createAction(ENTITY_CLEAN_ONE, function() {
    return Promise.resolve()
})

// SUBSCRIPTION
export const subscriptionGet = createAction(SUBSCRIPTION_GET, function (appCodename, query, params) {
    let queryParams = Object.assign({}, params, query)
    queryParams.sort = {
        createdAt: -1
    }
    return apiCall('get', '/api/v1/' + appCodename + '/subscriptions?populates=[{"key": "customer.internalId"}]', getHeaders(queryParams))
})

export const subscriptionGetOne = createAction(SUBSCRIPTION_GET_ONE, function(appCodename, subscriptionId) {
    return apiCall('get', '/api/v1/' + appCodename + '/subscriptions/' + subscriptionId, getHeaders())
})

export const subscriptionPutStatus = createAction(SUBSCRIPTION_PUT_STATUS, function(appCodename, subscriptionId) {
    return apiCall('put', '/api/v1/' + appCodename + '/subscriptions/status/' + subscriptionId + '?status=rejected', {}, getHeaders())
})

export const subscriptionClean = createAction(SUBSCRIPTION_CLEAN, function() {
    return Promise.resolve()
})

export const subscriptionCleanOne = createAction(SUBSCRIPTION_CLEAN_ONE, function() {
    return Promise.resolve()
})



// WEBPACK FOOTER //
// ./state/actions/index.js